export interface FAQItem {
  question: string;
  answer: string;
}

export const faqList: FAQItem[] = [
  {
    question: '51app 是什么？',
    answer: '51app 是国内领先的吃瓜爆料资讯平台，专注于收集和整理全网最热门的网红爆料、明星八卦、聊天记录曝光、视频爆料等内容。我们致力于为用户提供最新、最真实、最劲爆的网络热点资讯，让你第一时间掌握全网吃瓜动态。',
  },
  {
    question: '51app 上的内容真实吗？',
    answer: '51app 所有内容均来源于公开渠道和网络爆料，我们会对信息进行初步核实和筛选，标注信息来源。部分内容涉及当事人隐私，我们会进行适当处理。我们鼓励网友理性吃瓜，不造谣、不信谣、不传谣。',
  },
  {
    question: '如何下载安装 51app？',
    answer: '您可以在本网站首页点击"立即下载"按钮，或者扫描页面上的二维码进行下载。51app 支持 iOS 和 Android 双平台，下载完全免费。安装后注册即可使用，无需任何付费。',
  },
  {
    question: '可以在 51app 上爆料吗？',
    answer: '当然可以！如果您有劲爆的爆料内容，可以通过 app 内的"我要爆料"功能提交。我们会对所有爆料进行审核，保护爆料人的隐私安全。真实、有价值的爆料还有机会获得平台奖励。',
  },
  {
    question: '51app 收费吗？',
    answer: '51app 下载和使用完全免费。所有资讯内容均可免费阅读观看，不设置任何付费墙。我们的收入来源为页面广告展示，不会影响您的正常使用体验。',
  },
  {
    question: '如何联系 51app 官方？',
    answer: '您可以通过以下方式联系我们：客服邮箱 hello@lalaccu.cn、官方客服微信 51app_kefu、客服热线 400-888-5151（工作日 9:00-18:00）。如有商务合作需求，请发送至 hello@lalaccu.cn。',
  },
];